import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import Home from './pages/Home/Home';
import About from "./pages/About/About";
import Services from './pages/Services/Services';
import Works from './pages/Works/Works';
import Contact from './pages/Contact/Contact';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path = "/" element = {<Home />}></Route>
        <Route path = "/about" element = {<About />}></Route>
        <Route path = "/services" element = {<Services />}></Route>
        <Route path = "/works" element = {<Works />}></Route>
        <Route path = "/contact" element = {<Contact />}></Route>
      </Routes>
    </Router>
  );
}

export default App;